/**
 * ShiftLeft Digital Logo Component
 * Official ShiftLeft Digital branding logo
 */

import React from 'react';

interface SqlHealthProLogoProps {
  size?: number;
  className?: string;
}

export function SqlHealthProLogo({ size = 48, className = "" }: SqlHealthProLogoProps) {
  return (
    <div className={`inline-flex items-center justify-center ${className}`}>
      <img
        src="/logos/shiftleft_logo.png"
        alt="ShiftLeft Digital"
        width={size}
        height={size}
        className="object-contain"
      />
    </div>
  );
}
